import { Action } from '@ngrx/store';
import { ITravelBookingProgressBar } from '@shared/shared/interfaces/travel-booking-progress-bar.interfaces';

export const UPDATE_TRAVEL_BOOKING_BAR = '[Travel Progress Bar] Update travel progress booking bar';
export const UPDATE_TRAVEL_BOOKING_BAR_SUCCESS = '[Travel Progress Bar] Update travel progress booking bar success';

export const RESTORE_TRAVEL_BOOKING_BAR = '[Travel Progress Bar] Restore travel progress booking bar';
export const RESTORE_TRAVEL_BOOKING_BAR_SUCCESS = '[Travel Progress Bar] Restore travel progress booking bar success';

export const CLEAR_TRAVEL_BOOKING_BAR = '[Travel Progress Bar] Clear travel progress booking bar';
export const CLEAR_TRAVEL_BOOKING_BAR_SUCCESS = '[Travel Progress Bar] Clear travel progress booking bar success';

export class UpdateTravelBookingBar implements Action {
  readonly type = UPDATE_TRAVEL_BOOKING_BAR;
  constructor(public payload: any) {}
}

export class UpdateTravelBookingBarSuccess implements Action {
  readonly type = UPDATE_TRAVEL_BOOKING_BAR_SUCCESS;
  constructor(public payload: any) {}
}

export class RestoreTravelBookingBar implements Action {
  readonly type = RESTORE_TRAVEL_BOOKING_BAR;
}

export class RestoreTravelBookingBarSuccess implements Action {
  readonly type = RESTORE_TRAVEL_BOOKING_BAR_SUCCESS;
  constructor(public payload: ITravelBookingProgressBar) {}
}

export class ClearTravelBookingBar implements Action {
  readonly type = CLEAR_TRAVEL_BOOKING_BAR;
}

export class ClearTravelBookingBarSuccess implements Action {
  readonly type = CLEAR_TRAVEL_BOOKING_BAR_SUCCESS;
}

// action types
export type TravelBookingBarAction =
  | UpdateTravelBookingBar
  | UpdateTravelBookingBarSuccess
  | RestoreTravelBookingBar
  | RestoreTravelBookingBarSuccess
  | ClearTravelBookingBar
  | ClearTravelBookingBarSuccess;
